module.exports = __webpack_public_path__ + "img/charlie_face.eaf49b96.png";